import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import i18n from '@/libs/i18n'
import lang from 'element-ui/lib/locale/lang/en'
import VueCommaFilter from "vue-comma-filter";
import locale from 'element-ui/lib/locale'
import router from './router'
import store from './store'
import App from './App.vue'
import { installAuthSessionGuard } from '@/auth/session'
import '@/utils/firebase'
// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/tour'

// Axios Mock Adapter
if (process.env.NODE_ENV === 'development') {
  require('@/@fake-db/db')
}

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

// import font styles

require('@core/assets/fonts/web-fonts/fonts.css')

Vue.config.productionTip = false
installAuthSessionGuard(() => store.commit('permissions/RESET_PERMISSIONS'))

// configure language
locale.use(lang)

Vue.filter('currency', value => {
  if (typeof value !== 'number') {
    return value;
  }

  return `$${value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
})
Vue.use(VueCommaFilter);
new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
